
import { Header } from "@/components/Header";
import { OrganizationSettings as OrgSettings } from "@/components/organizations/OrganizationSettings";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OrganizationSettings = () => {
  const { session, isLoading } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!isLoading && !session) {
      navigate("/auth");
    }
  }, [session, isLoading, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <OrgSettings />
    </div>
  );
};

export default OrganizationSettings;
